import { call, put } from 'redux-saga/effects';
import * as actions from '../actions';
import * as api from '../../api';

export default function* fetchHomePageDataSaga(action) {
    try {
        yield put(actions.showLoading());
        const latestPosts = yield call(api.fetchPosts, { size: 5 });
        const promotionPosts = yield call(api.searchPostsApiService, {
            searchBy: 'promotion-code',
            pageNumber: 1,
            pageSize: 5,
        });
        const highlightPosts = yield call(api.getHighLightPosts);
        const applicationPosts = yield call(api.searchPostsApiService, {
            searchBy: 'application',
            pageNumber: 1,
            pageSize: 8,
        });
        yield put(actions.fetchHomePageData.getHomePageSuccess({
            latest: latestPosts.data.data || [],
            highLight: highlightPosts.data.data || [],
            promotionCodes: promotionPosts.data.data || [],
            applications: applicationPosts.data.data || [],
        }));
        yield put(actions.hideLoading());
    } catch (error) {
        console.log(error);
        yield put(actions.fetchHomePageData.getHomePageFailure(error));
        yield put(actions.hideLoading());
    }
}